import { action, makeObservable, observable, override } from 'mobx'
import { task } from 'mobx-task'
import { AlertFactory, AlertState } from 'alerts/Alert'
import Workspace from 'iam/models/Workspace'
import ModalViewModel from 'infra/ModalViewModel'
import { Id } from 'types/definitions'

export class PromoteToOwnerViewModel extends ModalViewModel {
  @observable
  workspace: Workspace = Workspace.none

  constructor(
    private _promoteToOwner: (workspaceId: string) => Promise<void>,
    private newAlert: AlertFactory,
  ) {
    super()
    makeObservable(this)
  }

  @action
  setWorkspace(workspace: Workspace) {
    this.workspace = workspace
  }

  showForWorkspace(workspace: Workspace) {
    this.setWorkspace(workspace)
    super.show()
  }

  promote = task.resolved(async () => {
    const alert = this.newAlert()
    const workspaceName = this.workspace.name

    try {
      await this._promoteToOwner(Id.assert(this.workspace.id))

      alert
        .withState(AlertState.Success)
        .saying('Success!', `You now have owner role in ${workspaceName}.`)
        .autoDismiss()
        .show()

      this.close()
    } catch (error) {
      alert.fromError('Error promoting to owner').autoDismiss().show()
    }
  })

  @action
  clear() {
    this.workspace = Workspace.none
  }

  @override
  close() {
    this.clear()
    super.close()
  }
}
